import { useState } from "react";
import Grid from '@mui/material/Grid';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../components/Dialog/DiaCompMedium";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { RecordsUpload } from "./RecordsUpload";

export default function DiaNewRecord() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>

        <Stack direction="column">
                
                <Typography variant="h6" sx={{ml: 4, mt:4, fontWeight: 300}}>Enter a new incident / record:</Typography>
        
                <Tooltip title="Add a new incident" placement="bottom">
                    <IconButton onClick={handleOpen} aria-label="add an alarm">
                        <AddCircleIcon fontSize="large" />
                    </IconButton>   
                </Tooltip>
        </Stack>
    

    <CustomDialog open={open} onClose={handleClose}

         title="Enter new incident / record"
          
          content = { <RecordsUpload /> }

        />
        
</>
)}